// extracted by mini-css-extract-plugin
export var wordContainer = "_m2-0";